<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/en22-1.jpg"
              width="100%"
              alt="蓝鲨 Robor 整车三模定位"
            />
          </div>
          <div class="text t22">
            <div class="fs_big1 t22_1 aniel" :class="{ ani: a1 }">整車定位</div>
            <div class="color_gray aniel" :class="{ ani1: a1 }">
              GPS + 北斗+ 4G 三模定位系統
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p22-2.jpg"
              width="100%"
              alt="蓝鲨 Robor 模拟引擎音"
            />
          </div>
          <div class="text t22">
            <div class="fs_big1 t22_1">模擬引擎音效</div>
            <div class="color_gray">產生油摩引擎轟鳴的聲音提醒行人注意來車</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      a1: false,
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    startani() {
      this.a1 = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t22 {
  top: 4vw;
  text-align: center;
  width: 100%;
  .t22_1 {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_tw/swiper22.vue